<template>
  <div class="modal-backdrop">
    <div class="confirm-modal">
      <!-- Header -->
      <div class="confirm-modal__header-container">
        <slot name="title"></slot>
        <img
          src="@/assets/EndOfLife/closeIcon.svg"
          alt="Close Icon"
          @click="$emit('no')"
        />
      </div>
      <!-- Content -->
      <div class="confirm-modal__content-footer-wrapper">
        <div class="confirm-modal__content-container">
          <slot name="description"></slot>
        </div>
        <!-- Footer / Buttons -->
        <div class="confirm-modal__footer-container">
          <button-global
            text="NO, KEEP"
            type="neutral"
            @eventPassed="$emit('no')"
          ></button-global>
          <button-global
            text="YES, DELETE"
            type="negative"
            @eventPassed="$emit('yes')"
          ></button-global>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonGlobal from "./ButtonGlobal";

export default {
  components: {
    ButtonGlobal,
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.$emit("no");
      }
    },
  },
  mounted: function () {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9998;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-modal {
  background-color: white;
  width: 600px;
  height: 300px;
  border-radius: 8px;
}

.confirm-modal__header-container {
  background-color: #894e99;
  color: white;
  height: 50%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  border-radius: 8px 8px 0 0;
}

.confirm-modal__header-container img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.confirm-modal__content-footer-wrapper {
  position: relative;
  top: -25%;
}

.confirm-modal__content-container {
  background-color: white;
  margin: 0 20px;
  padding: 15px;
  height: 135px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.5;
}

.confirm-modal__content-container p {
  margin-bottom: 0;
}

.confirm-modal__footer-container {
  padding: 0 20px 20px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 90px;
}
</style>
